import React, {Component} from "react";
import {Container, Row, Col, Card, CardBody} from "reactstrap";
import {connect} from "react-redux";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {withTranslation} from "react-i18next";
import Select from "react-select";
import PropTypes from "prop-types";
import {inboxFilter, inboxSegments} from "../../store/inbox/actions";
import SmartDropzone from "../../components/Common/SmartDropzone";
import * as url from "../../api/url";
import {formatBytes} from "../../common/general";

class Inbox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sections: [],
      segments: [],
      selectedSection: null,
    };
    this.onSelectSection = this.onSelectSection.bind(this)
    this.refreshSegments = this.refreshSegments.bind(this)
  }

  componentDidMount() {
    this.props.onInboxFilter({history: this.props.history});
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      this.setState({
        sections: this.props.responseFilter ? this.props.responseFilter.response.sections : [],
        loadingFilter: this.props.loadingFilter,
        errorFilter: this.props.errorFilter,
        segments: this.props.responseSegments ? this.props.responseSegments.response.segments : [],
        loadingSegments: this.props.loadingSegments,
        errorSegments: this.props.errorSegments,
      })
      if (prevProps.responseFilter === null && this.props.responseFilter && this.props.responseFilter.response.sections.length > 0) {
        const inboxSection = JSON.parse(localStorage.getItem("inboxSection"))
        if (inboxSection && this.props.responseFilter.response.sections.some(s => s.value === inboxSection.value)) {
          this.onSelectSection(inboxSection)
        } else {
          this.onSelectSection(this.props.responseFilter.response.sections[0])
        }
      }
    }
  }

  onSelectSection(selectedOption) {
    this.setState({
      selectedSection: selectedOption,
    });
    localStorage.setItem("inboxSection", JSON.stringify(selectedOption))
    this.props.onInboxSegments({data: {sectionId: selectedOption.value}, history: this.props.history});
  }

  refreshSegments() {
    this.onSelectSection(this.state.selectedSection)
  }

  render() {
    document.title = "Inbox | FileJet";
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <Breadcrumbs title={this.props.t("FileJet")} breadcrumbItem={this.props.t("Inbox")}/>
            <Row>
              <Col className="col-12">
                <Card>
                  <CardBody>
                    <Row>
                      <Col className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xxl-4">
                        Section
                        <Select options={this.state.sections} value={this.state.selectedSection} onChange={this.onSelectSection}/>
                      </Col>
                    </Row>
                    <Row className="mt-3">
                      {this.state.segments.map(segment => {
                        return (
                          <Col key={segment.id} className="col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xxl-2">
                            <Card className="shadow-none border">
                              <CardBody className="p-3">
                                <div className="avatar-xs me-3 mb-3">
                                  <div className="avatar-title bg-transparent rounded">
                                    <i className="bx bxs-folder font-size-24 text-warning"></i>
                                  </div>
                                </div>
                                <div>
                                  <div className="overflow-hidden me-auto">
                                    <h5 className="font-size-14 text-truncate mb-1">{segment.name}</h5>
                                  </div>
                                  <div className="d-flex">
                                    <div className="col-6"><p className="text-muted mb-0">{segment.count} Files</p></div>
                                    <div className="col-6" style={{"fontSize": ".7rem"}}><p className="text-muted mb-0 float-end">{formatBytes(segment.size)}</p></div>
                                  </div>
                                </div>
                                <SmartDropzone
                                  uploadUrl={url.API_FILES + "upload/"}
                                  sectionId={this.state.selectedSection.value}
                                  segmentId={segment.id}
                                  refreshSegments={this.refreshSegments}
                                  history={this.props.history}/>
                              </CardBody>
                            </Card>
                          </Col>
                        )
                      })}
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

Inbox.propTypes = {
  onInboxFilter: PropTypes.func,
  onInboxSegments: PropTypes.func,
};

const mapStateToProps = ({Inbox}) => ({
  responseFilter: Inbox.responseFilter,
  loadingFilter: Inbox.loadingFilter,
  errorFilter: Inbox.errorFilter,
  responseSegments: Inbox.responseSegments,
  loadingSegments: Inbox.loadingSegments,
  errorSegments: Inbox.errorSegments,
});

const mapDispatchToProps = dispatch => ({
  onInboxFilter: data => dispatch(inboxFilter(data)),
  onInboxSegments: data => dispatch(inboxSegments(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Inbox));
